import rhinoCore from 'rhino/src/core/core.module';
import * as rnChatService from './chat.service';

export default angular.module('rhino.components.chat', [rhinoCore])
  .service(rnChatService.name, rnChatService.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/chat/chat.module.js